export const ADMIN = 0;
export const CUSTOMER = 1;
export const SITE_MANAGER = 2;
export const DEMO = 3;

export const roleLabels = {
  [ADMIN]: 'Administratör',
  [CUSTOMER]: 'Kund',
  [SITE_MANAGER]: 'Platschef',
  [DEMO]: 'Demo',
};

export const roles = [{
  id: ADMIN,
  label: roleLabels[ADMIN],
}, {
  id: CUSTOMER,
  label: roleLabels[CUSTOMER],
}, {
  id: SITE_MANAGER,
  label: roleLabels[SITE_MANAGER],
}, {
  id: DEMO,
  label: roleLabels[DEMO],
}];



// WEBPACK FOOTER //
// ./src/roles.js